<wiz-vgroup width="100%" height="100%" gap="2" horizontalAlign="end" class="section-container">
  <wiz-hgroup width="100%" height="45px">
    <wiz-label #lbTitle width="100%" class="componentLabel"></wiz-label>
    <wiz-icon class="image-purple" width="30px" height="30px" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

    <wiz-ag-grid #agGrid
      width="100%"
      height="100%"
      [frameworkComponents]="gridFrameworkComponents"
      [wizDatasource]="mainDS"
      [columnDefs]="columns"
      [gridOptions]="gridOptions"
      [wizShowDelete]="true"
      (wizDeleteItem)="onItemDeleted($event)"
      class="ag-theme-alpine"
    ></wiz-ag-grid>

  <wiz-hgroup width="100%" verticalAlign="end" horizontalAlign="end" gap="2">
    <wiz-button
      #btnSave
      [wizLabel]="'$.pivot.filterkey.edit.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
